import { useId } from 'react'

export const useGroup = () => {
  const labelId = useId()
  const groupId = useId()
  const descriptionId = useId()
  return {
    groupProps: {
      id: groupId,
      'aria-labelledby': labelId,
      role: 'group',
      'aria-describedby': descriptionId,
    },
    labelProps: { id: labelId },
    descriptionProps: { id: descriptionId },
  } as const
}
